import { WidgetActions } from '../types';

export function setStatusWidget(payload: boolean): WidgetActions {
  return { type: 'SET_STATUS_WIDGET', payload };
}
